import pageReducer from "./pageReducer"
import { combineReducers } from "redux";


const rootReducer = combineReducers({
  pageReducer,
});
export default rootReducer;
